import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { useFreeTrialUpgradeModal } from '../../FreeTrialUpgradeModal/use-free-trial-upgrade-modal';
import './OfferText.pcss';

export const OfferText = ({ className = '' }: { className?: string }) => {
  const { isFreeTrialPromotionWithoutSubscription } =
    useFreeTrialUpgradeModal();

  const { november2021Pricing } = useSelector(combinedFeatureFlagsSelector);

  const mainOfferText = ` off your first 3 months of a monthly${
    !november2021Pricing ? ' OPERATOR and STARTUP plan.' : ' STARTUP plan.'
  }`;
  const consultingOfferText = 'FREE Premier Consulting';
  const consultingOfferEnding = ' session ($200 value) for all STARTUP plans.';

  return isFreeTrialPromotionWithoutSubscription ? (
    <div className={className}>
      Upgrade <strong>BEFORE</strong> your free trial ends to get{' '}
      <span className="offer-text__percentage">50%</span>
      {mainOfferText} Get <strong>{consultingOfferText}</strong>{' '}
      {consultingOfferEnding}.<br />
      <span className="offer-text__second-sentence">
        Use <strong className="offer-text__code">EARLYBIRD</strong> to claim
        your discount.
      </span>
    </div>
  ) : (
    <div className={className}>
      Upgrade now with code <strong>PREMIER</strong> to get{' '}
      <span className="offer-text__percentage">50%</span>
      {mainOfferText} Get <strong>{consultingOfferText}</strong>
      {consultingOfferEnding}
    </div>
  );
};
